import { DiscountCategory } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { BxgyMaxUsesPerOrderField } from "./fields/bxgy-max-uses-per-order-field";
import { CombineDiscountWithField } from "./fields/combine-discount-with-field";
import { CustomerBuysField } from "./fields/customer-buys-field";
import { CustomerEligibilityField } from "./fields/customer-eligibility-field";
import { CustomerGetsField } from "./fields/customer-gets-field";
import { ExpirationField } from "./fields/expiration-field";
import { LimitOncePerCustomerField } from "./fields/limit-once-per-customer-field";
import { StartDateTimeField } from "./fields/start-date-time-field";
import { TotalUsesField } from "./fields/total-uses-field";
import { DiscountSettingsSectionProps } from "./types";

export function ShopifyBxgySettings({
  formState,
  category,
}: DiscountSettingsSectionProps) {
  const isRecover = category === DiscountCategory.RECOVER;
  return (
    <>
      <CustomerBuysField
        collections={formState.bxgyTriggerCollections}
        itemType={formState.bxgyTriggerItemType}
        products={formState.bxgyTriggerProducts}
        setCollections={formState.setBxgyTriggerCollections}
        setItemType={formState.setBxgyTriggerItemType}
        setProducts={formState.setBxgyTriggerProducts}
        setTriggerAmount={formState.setBxgyTriggerAmount}
        setTriggerQuantity={formState.setBxgyTriggerQuantity}
        setTriggerType={formState.setBxgyTriggerType}
        triggerAmount={formState.bxgyTriggerAmount}
        triggerQuantity={formState.bxgyTriggerQuantity}
        triggerType={formState.bxgyTriggerType}
      />
      <CustomerGetsField
        collections={formState.bxgyRewardCollections}
        discountType={formState.bxgyRewardDiscountType}
        discountValue={formState.bxgyRewardDiscountValue}
        itemType={formState.bxgyRewardItemType}
        products={formState.bxgyRewardProducts}
        quantity={formState.bxgyRewardQuantity}
        setCollections={formState.setBxgyRewardCollections}
        setDiscountType={formState.setBxgyRewardDiscountType}
        setDiscountValue={formState.setBxgyRewardDiscountValue}
        setItemType={formState.setBxgyRewardItemType}
        setProducts={formState.setBxgyRewardProducts}
        setQuantity={formState.setBxgyRewardQuantity}
      />
      <BxgyMaxUsesPerOrderField
        setValue={formState.setBxgyUsesPerOrderLimit}
        value={formState.bxgyUsesPerOrderLimit}
      />
      <CombineDiscountWithField
        setValue={formState.setCombineDiscountWith}
        // Hide "Product discounts" option for BXGY discounts - BXGY IS a product discount and can't combine with other product discounts on the same items
        showProductDiscounts={false}
        showShippingDiscount
        value={formState.combineDiscountWith}
      />
      <ExpirationField
        category={category}
        codeGenerationStrategy={formState.codeGenerationStrategy}
        expiration={formState.expiration}
        setExpiration={formState.setExpiration}
      />
      {!isRecover && (
        <>
          <StartDateTimeField
            setStartDate={formState.setStartDate}
            setStartTime={formState.setStartTime}
            startDate={formState.startDate}
            startTime={formState.startTime}
          />
          <CustomerEligibilityField
            eligibility={formState.customerEligibility}
            onSegmentChange={formState.handleShopifySegmentChange}
            segmentOptions={formState.ShopifySegmentOptions}
            selectedCustomerIds={formState.selectedCustomerIds}
            selectedSegmentOptions={formState.selectedShopifySegmentOptions}
            setEligibility={formState.setCustomerEligibility}
            setSelectedCustomerIds={(customerIds) => {
              formState.setSelectedCustomerIdsString(customerIds.join(", "));
            }}
          />
          <TotalUsesField
            perCode={formState.perCodeDiscount}
            setUnlimited={formState.setUnlimitedUsage}
            setValue={formState.setTotalUsageLimit}
            unlimited={formState.unlimitedUsage}
            value={formState.totalUsageLimit}
          />
          <LimitOncePerCustomerField
            setValue={formState.setAppliesOncePerCustomer}
            value={formState.appliesOncePerCustomer}
          />
        </>
      )}
    </>
  );
}
